// extracted by mini-css-extract-plugin
export default {"contentWrapper":"purchase-table_contentWrapper__wJFkn","btnWrapper":"purchase-table_btnWrapper__hXnH5","btn":"purchase-table_btn__3XHfn"};